import {
  ShieldCheck,
  Scale,
  Lock,
  HandHeart,
  EyeOff,
} from "lucide-react";
import Reveal from "@/components/Reveal";

const SHIELDS = [
  { icon: Scale, k: "Legal Compliance" },
  { icon: ShieldCheck, k: "Transparent Process" },
  { icon: Lock, k: "Data Security" },
  { icon: HandHeart, k: "Ethical Practices" },
  { icon: EyeOff, k: "Customer Privacy" },
];

export default function ComplianceStrip() {
  return (
    <section
      id="compliance"
      data-testid="compliance-strip"
      className="relative bg-[#0A1F44] text-white py-20 md:py-24 overflow-hidden noise-overlay"
    >
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-[#0F6B3D] to-transparent" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <div className="text-center">
            <h2
              data-testid="compliance-heading"
              className="font-display text-[36px] md:text-[52px] leading-[1.05] tracking-tight"
            >
              Safe. <em className="not-italic text-[#D4AF37]">Secure.</em> Compliant.
            </h2>
            <p className="mt-3 text-white/70 max-w-2xl mx-auto">
              We follow the highest industry standards across every transaction, document and
              advisory engagement.
            </p>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-5">
          {SHIELDS.map(({ icon: Icon, k }, i) => (
            <Reveal key={k} delay={i * 80}>
              <div
                data-testid={`shield-${k.toLowerCase().replace(/\s+/g, "-")}`}
                className="group relative rounded-2xl py-7 px-4 text-center border border-[#D4AF37]/30 transition-all hover:-translate-y-1 hover:border-[#D4AF37]/80 overflow-hidden"
                style={{
                  background:
                    "linear-gradient(180deg, rgba(15,107,61,0.25) 0%, rgba(10,31,68,0.6) 100%)",
                }}
              >
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity"
                  style={{
                    background:
                      "radial-gradient(circle at 50% 0%, rgba(212,175,55,0.18), transparent 70%)",
                  }}
                />
                {/* Shield icon */}
                <div className="relative inline-flex items-center justify-center w-14 h-14 mx-auto">
                  <svg viewBox="0 0 64 64" className="absolute inset-0 text-[#D4AF37]" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M32 4 L56 14 V32 C56 46 32 60 32 60 C32 60 8 46 8 32 V14 Z" />
                  </svg>
                  <Icon size={22} strokeWidth={1.75} className="relative text-[#F0D788]" />
                </div>
                <div className="relative mt-4 font-display text-[13px] sm:text-sm uppercase tracking-wide text-white leading-tight break-words">
                  {k}
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={200}>
          <p
            data-testid="compliance-tagline"
            className="mt-12 text-center text-[#F0D788] font-script italic text-xl md:text-2xl"
          >
            Your Trust is Our Greatest Asset
          </p>
        </Reveal>
      </div>
    </section>
  );
}
